import { render, staticRenderFns } from "./CompTeclado.vue?vue&type=template&id=38db6321&"
import script from "./CompTeclado.vue?vue&type=script&lang=js&"
export * from "./CompTeclado.vue?vue&type=script&lang=js&"
import style0 from "./CompTeclado.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports